import React, { useEffect, useState } from 'react';
import { notification } from '../../hocs/notification';

import axios from 'axios';
import { mainurl } from '../../../Mainurl';

import { FaHeading } from 'react-icons/fa';
import { Row, Col, Card, CardBody, CardHeader, Form, FormGroup, Input, Label, InputGroup, InputGroupText, Spinner, Button } from 'reactstrap';

const AddVariety = ({ back }) => {
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState('');
    const [crop, setCrop] = useState('');
    const [cropTypeOpt, setCropTypeOpt] = useState('');
    const [cropOpt, setCropOpt] = useState('');
    const [cropType, setCropType] = useState('');

    //

    useEffect(() => {
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "lang_id": 1 }];
        axios({
            method: 'post',
            url: mainurl + 'Master/box_crop_type_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option value={row.crop_type_id}> {row.crop_type_name}</option>
                    )
                });

                setCropTypeOpt(list);
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }, [])

    const get_crop_list = (e) => {
        setCropOpt('');
        setCrop("0");
        setCropType(e.target.value);
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "crop_type_id": e.target.value, "lang_id": 1 }];

        axios({
            method: 'post',
            url: mainurl + 'Master/box_crop_master_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option value={row.crop_code}> {row.crop_name}</option>
                    )
                });

                setCropOpt(list);
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }


    const add_handler = (e) => {
        e.preventDefault();


        let postData = [{
            "org_id": sessionStorage.getItem('org_id'),
            "crop_variety_name": name,
            "crop_code": crop,

        }];

        console.log(postData);
        axios({
            method: 'post',
            url: mainurl + 'Common/crop_variety_add',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                if (response.data[0].retcode === 101) {
                    let notify = notification({ message: "Crop Variety added Successfully.", type: 'info', time: true, position: 'center' });
                    notify();
                    back();
                }
            })
            .catch(error => {
                let notify = notification({ message: "Submit failed! Try Again", type: 'error', time: true });
                notify();
            });
    }

    return (
        <>
            <Card className='mb-3' color="primary" outline>
                <CardHeader> Add New Variety </CardHeader>
                <CardBody>
                    <Form onSubmit={add_handler}>
                        <FormGroup row>

                            <Label sm={2}> Crop Type </Label>
                            <Col sm={4}>
                                <Input id="type" bsSize="sm" type="select" value={cropType} onChange={get_crop_list}>
                                    <option value="0"> --Select Crop Type--</option>
                                    {cropTypeOpt}
                                </Input>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label sm={2}> Crop </Label>
                            <Col sm={4}>
                                <Input id="type" bsSize="sm" type="select" value={crop} onChange={(e) => setCrop(e.target.value)}>
                                    <option value="0"> --Select Crop --</option>
                                    {cropOpt}
                                </Input>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="name" sm={2} > Crop Variety Name </Label>
                            <Col sm={4}>
                                <Input id="name" type='text' bsSize="sm" value={name} onChange={(e) => setName(e.target.value)} required />
                            </Col>
                        </FormGroup>
                        <Row>
                            <hr />
                            <Col md={2} className="mb-2">
                                <Button className='text-white' color='primary' size="sm" block> Submit </Button>
                            </Col>
                        </Row>
                    </Form>
                </CardBody>
            </Card>
            <div className='text-end'>
                <Button className='text-white' color='primary' size="sm" onClick={back}> Back </Button>
            </div>
        </>
    )
}

export default AddVariety;